import React, {FC} from "react";

const Spacer: FC = () => {
  return <>
    <div className="spacer"/>
    <style jsx>{`
      .spacer {
        margin: 3rem auto;
      }
    `}</style>
  </>
}

export default Spacer;
